import React from 'react';
import { HeartCrackIcon } from 'lucide-react';
const QUIET_THOUGHTS = ['“Mi hijo me dijo una vez, casi sin querer, que sus compañeros traían mejores cosas. Lo dijo sin malicia. Pero yo no lo olvidé.”', '“La lonchera volvió llena otra vez. Y estuve todo el día preguntándome si tuvo hambre. Si pudo concentrarse. Si alguien le preguntó por qué no comía.”', '“Vi una foto en el grupo de WhatsApp de madres. La merienda de otra mamá. Cerré el celular y no dije nada.”', '“Son las 11 de la noche. Recién me acuerdo que mañana es miércoles. Estoy agotada. Pero igual me levanto a ver qué hay.”', '“Mi hijo me preguntó por qué siempre le mando lo mismo. Le dije que era porque era lo que más le gustaba. Pero los dos sabemos que no era verdad.”'];
export function PainAndProduct() {
  return <>
      <section className="bg-white px-4 py-20" data-id="element-94" data-mp="20f6yb6k7amlx">
        <div className="mx-auto max-w-3xl text-center" data-id="element-95" data-mp="20hjdjbykqiva">
          <p className="font-display text-sm font-bold uppercase tracking-[0.16em] text-brand-orange" data-id="element-96" data-mp="24i3aofj5dmhf">
            El momento que todas conocen
          </p>
          <h2 className="mt-3 font-display text-3xl font-bold text-brand-deep md:text-4xl" data-id="element-97" data-mp="28x10hzyj854v">
            La herida que nadie nombra
          </h2>
          <div className="mt-9 space-y-6 text-lg leading-relaxed text-brand-text md:text-xl" data-id="element-98" data-mp="2mxliwv0jbyxu">
            <p className="font-medium" data-id="element-99" data-mp="2iu5qkavi0kqy">
              Hay un momento que casi todas las mamás uruguayas conocen.
            </p>
            <p data-id="element-100" data-mp="2wt58z0sf43eo">
              El mate está frío. Los chicos todavía no se levantaron. Y vos ya
              estás parada frente a la heladera con esa pregunta de siempre.
            </p>
            <p className="font-display text-2xl font-bold text-brand-deep md:text-3xl" data-id="element-101" data-mp="36k9smdt1gcfu">
              “¿Qué le pongo hoy de merienda?”
            </p>
            <p data-id="element-102" data-mp="3fl7uapg087v9">
              Agarrás lo mismo de siempre. O comprás algo de camino. O mandás lo
              que quedó de ayer. Pero lo que duele de verdad es lo que viene
              después.
            </p>
          </div>
          <blockquote className="my-11 rounded-2xl border border-brand-sky bg-brand-lightBlue p-7 font-display text-xl font-bold italic leading-relaxed text-brand-deep" data-id="element-103" data-mp="28a1kason3n78">
            “Mientras tanto · tu hijo está en el colegio. Abre la lonchera. Y
            vuelve a ver lo mismo de siempre.”
          </blockquote>
          <h2 className="font-display text-3xl font-bold text-brand-orange md:text-4xl" data-id="element-104" data-mp="2m1y4mak2gst2">
            Eso tiene que terminar.
          </h2>
          <p className="mt-6 text-lg leading-relaxed text-brand-text md:text-xl" data-id="element-105" data-mp="2vyksl87ovzzb">
            No porque la merienda sea lo más importante del mundo. Sino porque
            ya hay un sistema que resuelve esto.
          </p>
          <p className="mt-6 text-lg leading-relaxed text-brand-text md:text-xl" data-id="element-106" data-mp="34zivfn6e61gb">
            Alguien ya organizó 60 ideas por situación real. Ya escribió recetas
            simples con ingredientes uruguayos. Ya armó el planificador de 4
            semanas completo. Ya calculó los costos con precios reales de
            Uruguay.
          </p>
          <p className="mt-7 text-lg leading-relaxed text-brand-text md:text-xl" data-id="element-107" data-mp="133s491vtfuu0">
            Y ese trabajo está disponible para vos · ahora mismo · en un PDF que
            descargás hoy y usás mañana.
            <br data-id="element-108" data-mp="t9t2w53kgf34" />
            <strong className="text-brand-deep" data-id="element-109" data-mp="paairbjkk81c">
              Eso es Meriendas que Acompañan.
            </strong>
          </p>
        </div>
      </section>

      <section className="bg-brand-base px-4 py-20" data-id="element-110" data-mp="1m01hjmyw8hcy">
        <div className="mx-auto max-w-5xl" data-id="element-111" data-mp="1h0ym8u8ptpi6">
          <header className="mx-auto mb-12 max-w-3xl text-center" data-id="element-112" data-mp="1h200f7l12s44">
            <p className="font-display text-sm font-bold uppercase tracking-[0.16em] text-brand-orange" data-id="element-113" data-mp="1cz3lbqup5e4x">
              Lo que realmente duele
            </p>
            <h2 className="mt-3 font-display text-3xl font-bold text-brand-deep md:text-4xl" data-id="element-114" data-mp="1834orfz7sptf">
              Lo que se dicen solas cuando nadie las escucha
            </h2>
          </header>
          <div className="grid gap-5 md:grid-cols-2" data-id="element-115" data-mp="3st3xhro332x3">
            {QUIET_THOUGHTS.map(thought => <article key={thought} className="flex gap-4 rounded-2xl border border-rose-100 bg-white p-6 shadow-sm" data-id="element-116" data-mp="1kgi0465f0q6d">
                <HeartCrackIcon className="mt-1 h-6 w-6 shrink-0 text-rose-400" data-id="element-117" data-mp="1bj7o2ikrwx0e" />
                <p className="font-medium leading-relaxed text-brand-text" data-id="element-118" data-mp="1fk9q1762rn62">
                  {thought}
                </p>
              </article>)}
          </div>
          <div className="mx-auto mt-12 max-w-2xl text-center" data-id="element-119" data-mp="288fb5v11je6f">
            <p className="font-display text-2xl font-bold text-brand-deep md:text-3xl" data-id="element-120" data-mp="285t21qyi4qm3">
              “¿Soy buena madre si no puedo resolver algo tan simple?”
            </p>
            <p className="mt-5 text-lg font-medium leading-relaxed text-brand-text" data-id="element-121" data-mp="1z5nvfj14tw8z">
              Esa pregunta tiene que dejar de existir. Y este MEGAPACK existe
              exactamente para eso.
            </p>
          </div>
        </div>
      </section>

      <section className="bg-white px-4 py-20" data-id="element-122" data-mp="faiecf4o5r4n">
        <div className="mx-auto max-w-3xl text-center" data-id="element-123" data-mp="f98dxjacg6uu">
          <h2 className="font-display text-3xl font-bold text-brand-deep md:text-4xl" data-id="element-124" data-mp="ba7xu8j93ibj">
            No es que no hayas intentado resolver esto.
          </h2>
          <div className="mt-8 space-y-6 text-lg leading-relaxed text-brand-text" data-id="element-125" data-mp="p74vastvjy1e">
            <p data-id="element-126" data-mp="kaxoyyxkgkix">
              Lo intentaste con cuentas de Instagram de loncheras hermosas. Las
              miraste, te inspiraste, y el lunes a las 7 no pudo replicarse
              ninguna.
            </p>
            <p data-id="element-127" data-mp="3nos4ubnjld6q">
              Lo intentaste con PDFs gratuitos de recetas saludables. Pasaste
              más tiempo filtrando lo que no era de Uruguay que usando lo que sí
              servía.
            </p>
            <p data-id="element-128" data-mp="39zgj99x4a7ef">
              Lo intentaste armando tu propio sistema. Funcionó dos semanas.
              Después vino una semana complicada y se desarmó todo.
            </p>
          </div>
          <div className="mt-12 rounded-3xl bg-brand-deep p-8 text-left text-white shadow-xl md:p-10" data-id="element-129" data-mp="34yj1gyg0rfdg">
            <p className="text-xl font-medium text-brand-sky" data-id="element-130" data-mp="18ve99gl34v2d">
              El problema no es tu dedicación.
              <br data-id="element-131" data-mp="1inab92qal5bv" />
              El problema no es tu amor por tus hijos.
            </p>
            <p className="mt-6 text-xl font-bold leading-relaxed md:text-2xl" data-id="element-132" data-mp="1mom3zh4gq6oa">
              El problema es que nunca tuviste un sistema completo · listo ·
              adaptado a la realidad uruguaya · con todo integrado.
            </p>
            <p className="mt-8 font-display text-3xl font-bold text-brand-orange" data-id="element-133" data-mp="uyhc6xedihd1">
              Hasta hoy.
            </p>
          </div>
        </div>
      </section>

      <section className="relative overflow-hidden bg-brand-deep px-4 py-20 text-center text-white" data-id="element-134" data-mp="13xw13sew6jvf">
        <div className="relative mx-auto max-w-4xl" data-id="element-135" data-mp="2aegehs1b7j5d">
          <span className="inline-flex rounded-full border border-white/20 bg-white/10 px-5 py-2 text-sm font-bold" data-id="element-136" data-mp="2adomssau25kd">
            🏆 El sistema que eligen las familias uruguayas
          </span>
          <p className="mt-8 text-sm font-bold uppercase tracking-[0.18em] text-brand-orange" data-id="element-137" data-mp="2pgq0xfk07w9z">
            🐦‍🔥 Tu Fénix Digital
          </p>
          <h2 className="mt-3 font-display text-4xl font-bold md:text-6xl" data-id="element-138" data-mp="2frepvndk4hjg">
            MERIENDAS QUE <span className="text-brand-orange" data-id="element-139" data-mp="2bpt93qxwjj3z">ACOMPAÑAN</span>
          </h2>
          <p className="mx-auto mt-6 max-w-2xl text-xl font-medium leading-relaxed text-brand-sky md:text-2xl" data-id="element-140" data-mp="2bnql1cgb801w">
            El sistema de planificación de meriendas escolares más completo para
            familias uruguayas.
          </p>
          <p className="mt-5 text-lg text-slate-300" data-id="element-141" data-mp="1ws0ur243d0rd">
            100% PDF. Acceso inmediato. Adaptado al presupuesto y al tiempo de
            las familias uruguayas 2026.
          </p>
        </div>
      </section>
    </>;
}